import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#F5F5F5', // Light gray background
      paper: '#FFFFFF',   // White paper background
    },
    primary: {
      main: '#2E7D32',   // Softer green
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#388E3C',   // Produce button - soft green
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#D32F2F',   // Do Not Produce button - soft red
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#E65100',   // Attorney-Client Privilege button - soft orange
      light: '#FFE0B2',  // Highlight color for search - soft orange highlight
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#1B5E20',    // Dark green for primary text
      secondary: '#33691E',  // Darker green for secondary text
    },
  },
  typography: {
    fontFamily: "'Arial', 'Courier New', monospace",
    h5: {
      color: '#1B5E20',
    },
    body1: {
      fontSize: '1.1rem',
      letterSpacing: '0.5px',
      color: '#2E7D32',
    },
    subtitle2: {
      color: '#33691E',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid #2E7D32',
          boxShadow: '0 0 10px rgba(46, 125, 50, 0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#2E7D32',
            },
            '&:hover fieldset': {
              borderColor: '#1B5E20',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1B5E20',
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2E7D32',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1B5E20',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1B5E20',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: "'VT323', 'Courier New', monospace",
          fontSize: '1.1rem',
          '&.MuiButton-containedInherit': {
            backgroundColor: '#F5F5F5',
            color: '#2E7D32',
            '&:hover': {
              backgroundColor: '#E8F5E9',
            },
          },
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          '& .MuiButton-root': {
            borderColor: '#2E7D32',
          },
        },
      },
    },
  },
})

export default theme; 